module.exports = __webpack_public_path__ + "b4f7355a484e9dcf52814ae0fef2171d.png";